const heatmapdata = [
  {
    id: "Japan",
    data: [
      {
        x: "Train",
        y: 28238,
      },
      {
        x: "Subway",
        y: -30271,
      },
      {
        x: "Bus",
        y: 43541,
      },
      {
        x: "Car",
        y: 58830,
      },
      {
        x: "Boat",
        y: 75641,
      },
      {
        x: "Moto",
        y: 30057,
      },
      {
        x: "Moped",
        y: -39630,
      },
      {
        x: "Bicycle",
        y: -97981,
      },
      {
        x: "Others",
        y: -15929,
      },
    ],
  },
  {
    id: "France",
    data: [
      {
        x: "Train",
        y: -14079,
      },
      {
        x: "Subway",
        y: -95597,
      },
      {
        x: "Bus",
        y: -73065,
      },
      {
        x: "Car",
        y: -2089,
      },
      {
        x: "Boat",
        y: -14491,
      },
      {
        x: "Moto",
        y: -14658,
      },
      {
        x: "Moped",
        y: 21841,
      },
      {
        x: "Bicycle",
        y: 65965,
      },
      {
        x: "Others",
        y: -50096,
      },
    ],
  },
  {
    id: "US",
    data: [
      {
        x: "Train",
        y: 90607,
      },
      {
        x: "Subway",
        y: 68744,
      },
      {
        x: "Bus",
        y: -2744,
      },
      {
        x: "Car",
        y: -84194,
      },
      {
        x: "Boat",
        y: 66221,
      },
      {
        x: "Moto",
        y: -47254,
      },
      {
        x: "Moped",
        y: -46739,
      },
      {
        x: "Bicycle",
        y: -17492,
      },
      {
        x: "Others",
        y: -95876,
      },
    ],
  },
  {
    id: "Germany",
    data: [
      {
        x: "Train",
        y: 69562,
      },
      {
        x: "Subway",
        y: 78379,
      },
      {
        x: "Bus",
        y: 37495,
      },
      {
        x: "Car",
        y: 67256,
      },
      {
        x: "Boat",
        y: -98706,
      },
      {
        x: "Moto",
        y: -36513,
      },
      {
        x: "Moped",
        y: -45680,
      },
      {
        x: "Bicycle",
        y: 77582,
      },
      {
        x: "Others",
        y: 52859,
      },
    ],
  },
  {
    id: "Norway",
    data: [
      {
        x: "Train",
        y: -97350,
      },
      {
        x: "Subway",
        y: 75263,
      },
      {
        x: "Bus",
        y: -36485,
      },
      {
        x: "Car",
        y: -35325,
      },
      {
        x: "Boat",
        y: -21449,
      },
      {
        x: "Moto",
        y: 1325,
      },
      {
        x: "Moped",
        y: -74937,
      },
      {
        x: "Bicycle",
        y: 70288,
      },
      {
        x: "Others",
        y: -95813,
      },
    ],
  },
  {
    id: "Iceland",
    data: [
      {
        x: "Train",
        y: -2253,
      },
      {
        x: "Subway",
        y: -42986,
      },
      {
        x: "Bus",
        y: -34045,
      },
      {
        x: "Car",
        y: -83177,
      },
      {
        x: "Boat",
        y: 26136,
      },
      {
        x: "Moto",
        y: 59020,
      },
      {
        x: "Moped",
        y: 77815,
      },
      {
        x: "Bicycle",
        y: -95796,
      },
      {
        x: "Others",
        y: 34182,
      },
    ],
  },
  {
    id: "UK",
    data: [
      {
        x: "Train",
        y: -31602,
      },
      {
        x: "Subway",
        y: -74129,
      },
      {
        x: "Bus",
        y: 66875,
      },
      {
        x: "Car",
        y: 26428,
      },
      {
        x: "Boat",
        y: 20485,
      },
      {
        x: "Moto",
        y: 57730,
      },
      {
        x: "Moped",
        y: 6630,
      },
      {
        x: "Bicycle",
        y: -62400,
      },
      {
        x: "Others",
        y: 54142,
      },
    ],
  },
  {
    id: "Vietnam",
    data: [
      {
        x: "Train",
        y: -74505,
      },
      {
        x: "Subway",
        y: 15554,
      },
      {
        x: "Bus",
        y: -97752,
      },
      {
        x: "Car",
        y: 36798,
      },
      {
        x: "Boat",
        y: 75276,
      },
      {
        x: "Moto",
        y: -62306,
      },
      {
        x: "Moped",
        y: -28371,
      },
      {
        x: "Bicycle",
        y: 16453,
      },
      {
        x: "Others",
        y: 35694,
      },
    ],
  },
];
export default heatmapdata;